import React from 'react';
import ClassNames from 'classnames';
import TabTemplate from 'components/tabs/TabTemplate';
import StylePropable from 'mixins/js/StylePropable.js';
import Colors from 'mixins/js/colors.js';


export default React.createClass({

	mixins: [StylePropable],

	propTypes: {
		handleTouchTap: React.PropTypes.func,
		selected: React.PropTypes.bool,
		disabled: React.PropTypes.bool
	},

	handleTouchTap: function(){
		this.props.handleTouchTap(this.props.tabIndex, this);
	},

	render: function(){
		let styles = this.mergeAndPrefix({
			'width': this.props.width
		});

		let classes = ClassNames('lui-tab-item' , {
			'lui-tab-is-active' : this.props.selected,
			'lui-tab-is-disabled' : this.props.disabled
		});

		return (
		<div style={styles} className={classes} onClick={this.handleTouchTap} routeName={this.props.route}>
			{this.props.label}
		</div>
		)
	}

});


/** WEBPACK FOOTER **
 ** ./src/components/tabs/Tab.js
 **/